import { getUploader } from '~/uploads/lib/uploader/UploadersMap';
import { Upload } from '../../entities/Upload';
import { selectUploadById } from '../selectors';
import { uploadRemoved } from '../slice';

export const removeUpload =
  ({ id }: Pick<Upload, 'id'>) =>
  async (dispatch, getState): Promise<void> => {
    const upload = selectUploadById(getState(), id);

    if (!upload) return;

    if (upload.uploaderId) {
      getUploader(upload).removeUpload(upload);
    }

    if (upload) {
      dispatch(uploadRemoved(upload));
    }
  };
